import { formatDateValue } from "./helpers";
export function datePillNodeSpec() {
    return {
        date_pill: {
            inline: true,
            group: "inline",
            isolating: true,
            atom: true,
            attrs: {
                date: { default: null },
            },
            parseDOM: [
                {
                    tag: "span[data-date]",
                    getAttrs: (dom) => ({
                        class: "date-pill",
                        date: dom.getAttribute("data-date"),
                    }),
                },
            ],
            toDOM: (node) => {
                const { date } = node.attrs;
                return [
                    "span",
                    { class: "date-pill", "data-date": date },
                    formatDateValue(date),
                ];
            },
        },
    };
}
